import { createMergeReducer } from '../utils/reducer'
import * as WpsTypes from 'DVWebNodeWpsRuntime'

export type BottomBar = WpsTypes.atv.wps.BottomBarModelProps

export const reducer = createMergeReducer(
  t => t.bottomBar,
  {} as BottomBar
)